import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap";
import HelpAccordion from "../../pages/Help/components/HelpAccordion";
import { HELP_CATEGORIES } from "../../pages/Help/constants/helpData";

const HelpWidget = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [offcanvasOpen, setOffcanvasOpen] = useState(false);

    const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);
    const toggleOffcanvas = () => setOffcanvasOpen(!offcanvasOpen);
    const location = useLocation();

    if (location.pathname.startsWith('/kiosk')) {
        return null;
    }

    const phoneNumber = "5579996680315";
    const message = encodeURIComponent("Olá! Estou no NeoApp e gostaria de falar com o suporte.");
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

    return (
        <React.Fragment>
            <Dropdown 
                isOpen={dropdownOpen} 
                toggle={toggleDropdown} 
                direction="up" 
                className="floating-support-btn"
            >
                <DropdownToggle
                    tag="button"
                    className="btn btn-primary shadow-lg d-flex justify-content-center align-items-center rounded-circle p-0"
                    style={{ width: "60px", height: "60px", border: "none" }}
                >
                    <i className="ph-light ph-headset" style={{ fontSize: "28px" }}></i>
                </DropdownToggle>
                
                <DropdownMenu className="shadow-lg border-0 mb-2" end>
                    <DropdownItem className="py-2" onClick={toggleOffcanvas}>
                        <i className="ph-light ph-book-open text-primary me-2 font-size-18 align-middle"></i>
                        <span className="align-middle fw-medium">Manuais e Tutoriais</span>
                    </DropdownItem>
                    <DropdownItem divider className="my-1" />
                    <DropdownItem tag="a" href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="py-2">
                        <i className="ph-light ph-whatsapp-logo text-success me-2 font-size-18 align-middle"></i>
                        <span className="align-middle fw-medium">Falar com Suporte (WhatsApp)</span>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>

            <Offcanvas
                isOpen={offcanvasOpen}
                toggle={toggleOffcanvas}
                direction="end"
                style={{ width: "450px" }}
                className="border-start border-0 shadow-lg"
            >
                <OffcanvasHeader toggle={toggleOffcanvas} className="border-bottom bg-light">
                    <div className="d-flex align-items-center">
                        <div className="avatar-xs me-3">
                            <span className="avatar-title rounded-circle bg-primary-subtle text-primary font-size-22">
                                <i className="ph-light ph-lifebuoy"></i>
                            </span>
                        </div>
                        <div>
                            <h5 className="font-size-15 mb-0">Base de Conhecimento</h5>
                            <p className="text-muted font-size-13 mb-0">Manuais e passo a passo</p>
                        </div>
                    </div>
                </OffcanvasHeader>
                <OffcanvasBody className="p-4" style={{ backgroundColor: "#f8f9fa", overflowY: "auto" }}>
                    {HELP_CATEGORIES.map((category) => (
                        <HelpAccordion key={category.id} category={category} />
                    ))}
                    
                    <div className="text-center mt-5 mb-3">
                        <p className="text-muted font-size-13 mb-3">Ainda com dúvidas? Nós te ajudamos!</p>
                        <a 
                            href={whatsappUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-success w-100 rounded-pill d-flex justify-content-center align-items-center"
                            style={{ height: "45px" }}
                        >
                            <i className="ph-light ph-whatsapp-logo font-size-18 me-2"></i> Falar com Suporte Humano
                        </a>
                    </div>
                </OffcanvasBody>
            </Offcanvas>
        </React.Fragment>
    );
};

export default HelpWidget;
